import React from "react";

function GvarPattern() {
  return (
    <pattern
      width={4}
      height={4}
      patternUnits="userSpaceOnUse"
      patternTransform="rotate(45 50 50)"
      id="gvar"
    >
      <line
        className="tw-stroke-current tw-text-indigo-300"
        strokeWidth="4"
        y2={20}
      />
    </pattern>
  );
}

export default GvarPattern;
